module.exports = __webpack_public_path__ + "assets/95a65c497337868ea1bc030d290efab3.mp3";